import React, { useState } from 'react';
import { Button, Card, Form, Input, Space, Typography, message } from 'antd';
import { LockOutlined, MailOutlined } from '@ant-design/icons';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../auth/AuthContext';
import './authPages.css';

type LoginFormValues = {
  email: string;
  password: string;
};

export function LoginPage() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [submitting, setSubmitting] = useState(false);

  const onFinish = async (values: LoginFormValues) => {
    setSubmitting(true);
    try {
      await login(values);
      navigate('/dashboard', { replace: true });
    } catch (err: any) {
      message.error(err?.response?.data?.message || err?.message || 'Login failed');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="authShell">
      <Space direction="vertical" size={16} className="authSpace" style={{ maxWidth: 520, margin: '0 auto' }}>
        <Typography.Title level={2} className="authTitle" style={{ margin: 0 }}>
          Log in
        </Typography.Title>
        <Typography.Text type="secondary" className="authHelp">
          Use your email and password to access your dashboard.
        </Typography.Text>
        <Card className="authCard">
        <Form
          layout="vertical"
          onFinish={onFinish}
          autoComplete="on"
          requiredMark="optional"
        >
          <Form.Item
            name="email"
            label="Email"
            rules={[
              { required: true, message: 'Please enter your email' },
              { type: 'email', message: 'Please enter a valid email' },
            ]}
          >
            <Input prefix={<MailOutlined />} placeholder="user@example.com" />
          </Form.Item>

          <Form.Item
            name="password"
            label="Password"
            rules={[{ required: true, message: 'Please enter your password' }]}
          >
            <Input.Password prefix={<LockOutlined />} placeholder="securePassword123" />
          </Form.Item>

          <Form.Item>
            <Button type="primary" htmlType="submit" block loading={submitting}>
              Log in
            </Button>
          </Form.Item>

          <Typography.Text type="secondary">
            Don&apos;t have an account? <Link to="/signup">Sign up</Link>
          </Typography.Text>
        </Form>
        </Card>
      </Space>
    </div>
  );
}

